type OrganizationLifecycle = { lifecycle?: string | null };

// An archived organization's history moved to Lime's store: it can be read, never changed.
export function isArchivedOrganization(
  organization: OrganizationLifecycle | null | undefined,
): boolean {
  return organization?.lifecycle === "archived";
}
